/**
 * Payment Link Service
 *
 * Service for generating payment links for invoices.
 * Currently returns mock URLs. Ready for Stripe integration.
 */

/**
 * Generate a payment link for an invoice
 * 
 * @param invoiceId - The invoice ID
 * @returns Mock payment link URL
 */
export function generatePaymentLink(invoiceId: string): string {
  // Mock payment link - replace with Stripe Payment Link API in future
  return `https://pay.regalcredit.com/invoice/${invoiceId}`;
}

/**
 * Validate payment link format
 * 
 * @param link - The payment link to validate
 * @returns True if link is valid format
 */
export function isValidPaymentLink(link: string): boolean {
  try {
    const url = new URL(link);
    return url.protocol === 'https:' && url.hostname.includes('regalcredit.com');
  } catch {
    return false;
  }
}
